<template>
  <div>
    <div class="topview" @click="godetael()">
      <span>余额明细</span>
    </div>
    <div class="chongbanner">
      <p class="top">钱包</p>
      <p class="midle">{{ account }}</p>
      <p class="bottom">可用于支付运费及增值服务</p>
      <div class="anchong" @click="chonzhi()">
        <span>立即充值</span>
      </div>
    </div>
  </div>
</template>
<script>
import {Toast} from "mand-mobile";

export default {
  name: "Chongzhi",
  data() {
    return {
      account: 0.00,
    };
  },
  activated() {
    Toast.loading('请稍等....');
    this.getcreduit();
  },

  methods: {
    getcreduit() {
      this.ajax.AJAx(this.ports.getUserAccount, "post").then((res) => {
        const { money } = res;
        this.account = (money / 100).toFixed(2);
        Toast.hide()
      });
    },
    godetael() {
      this.$router.push({
        name: "ListDetail",
      });
    },
    chonzhi() {
      this.$router.push({
        name: "ChongzhiList",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.topview {
  width: 96%;
  margin-left: 2%;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.3rem;
}
.chongbanner {
  width: 96%;
  margin-left: 2%;
  color: white;
  height: 3rem;
  border-radius: 0.2rem;
  background-color: #ff3a30;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  p {
    width: 90%;
    margin-left: 5%;
    text-align: left;
  }
  .top {
    font-size: 0.3rem;
    font-weight: 500;
  }
  .midle {
    font-size: 0.42rem;
    font-weight: bold;
    padding: 0.2rem 0;
  }
  .bottom {
    font-size: 0.2rem;
  }
  .anchong {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    width: 1.8rem;
    height: 0.6rem;
    border: 1px solid white;
    border-radius: 0.1rem;
    right: 0.2rem;
  }
}
</style>
